export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14581.a6e1adb5.jpg";